import cx from 'classnames';
import { forwardRef } from 'react';
import TrackWrapper from '~/components/common/TrackWrapper';

export type OwnProps = {
  analyticsSection: string;
  children: React.ReactNode;
  className?: string;
  hasBottomSpacing?: boolean;
  hasSideSpacing?: boolean;
  hasTopSpacing?: boolean;
  style?: React.CSSProperties;
};

const SectionWrapper = forwardRef<HTMLDivElement, OwnProps>(
  function SectionWrapper(
    {
      analyticsSection,
      children,
      className,
      hasSideSpacing,
      hasBottomSpacing,
      hasTopSpacing,
      style
    },
    ref
  ) {
    const viewEvent = {
      customAttributes: {
        action: 'viewed',
        section: analyticsSection
      },
      eventName: 'Home Feed Section'
    };

    return (
      <TrackWrapper
        className="flex w-full justify-center bg-background-default"
        event={viewEvent}
        trackOnce
      >
        <div
          ref={ref}
          style={style}
          className={cx(
            // width 1272 + side padding 80 on lg = 1352
            'w-full max-w-[1352px]',
            {
              'px-2xl sm:px-3xl lg:px-4xl': hasSideSpacing,
              'pb-4xl md:pb-7xl': hasBottomSpacing,
              'pt-4xl md:pt-7xl': hasTopSpacing
            },
            className
          )}
        >
          {children}
        </div>
      </TrackWrapper>
    );
  }
);

export default SectionWrapper;
